import React from 'react';
import { useWindowResize } from '../hooks/useWindowResize';
import { useFullscreenLoader } from '../hooks/useFullscreenLoader';
import { getResizeMediaUrl } from '@wix/native-pro-gallery-utils';
import { GALLERY_CONSTS } from 'pro-gallery-lib';
const VIEWER_SELECTOR = '#SITE_CONTAINER';
export default function FullscreenWrapper(props) {
  const [container] = useWindowResize();
  const [isFullscreenLoaded, FullscreenElement] = useFullscreenLoader();
  const eventsListener = eventName => {
    switch (eventName) {
      case 'CLOSE_FULLSCREEN':
        if (props.setFullscreenIdx) {
          props.setFullscreenIdx(-1);
        }
        break;
      default:
        break;
    }
  };
  return isFullscreenLoaded ? /*#__PURE__*/React.createElement("div", {
    className: "pro-fullscreen-wrapper",
    style: props.rootCss
  }, /*#__PURE__*/React.createElement(FullscreenElement, {
    forceProGallerySlider: true,
    items: props.items,
    initialIdx: props.fullscreenIdx,
    totalItemsCount: props.items.length,
    container: props.container ? props.container : container,
    locale: props.locale
    // homeGalleryPageUrl={pageUrl}
    ,
    styles: props.options,
    isAccessible: props.isAccessible,
    galleryId: props.galleryId,
    viewMode: props.viewMode,
    noFollowForSEO: props.noFollowForSEO,
    eventsListener: eventsListener,
    itemsLoveData: [],
    deviceType: props.deviceType,
    isPreview: props.viewMode === GALLERY_CONSTS.viewMode.PREVIEW,
    animationDuration: props.animationDuration,
    shouldUseNewSocialSharePopup: false,
    createMediaUrl: props.createMediaUrl || getResizeMediaUrl,
    staticMediaUrls: props.staticMediaUrls,
    backgroundFilterElementSelector: props.backgroundFilterElementSelector || VIEWER_SELECTOR
  })) : null;
}
//# sourceMappingURL=fullscreenWrapper.js.map